import { render, staticRenderFns } from "./ChartsTab.vue?vue&type=template&id=5ce81e93&scoped=true&"
import script from "./ChartsTab.vue?vue&type=script&lang=js&"
export * from "./ChartsTab.vue?vue&type=script&lang=js&"
import style0 from "./ChartsTab.vue?vue&type=style&index=0&id=5ce81e93&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce81e93",
  null
  
)

export default component.exports